export const DISCORD_DEBUG_MODE_ENABLED = 'discord.debugModeEnabled';
export const DISCORD_MAX_PARTY_SIZE = 'discord.maxPartySize';
